const loadView = (view) => () => import(`../views/${view}.vue`).then(m => m.default || m);
export default [
    {
        component: loadView('province'),
        path: '/',
        name: 'province',
    },
    {
        component: loadView('home'),
        path: '/province/:slug',
        name: 'listing',
    },
    {
        component: loadView('login'),
        path: '/p/:short_token',
        name: 'login',
    },{
        component: loadView('auth/access'),
        path: '/access',
        name: 'access_token',
        
    },  
    {
        component: loadView('under_maintenance'),
        path: '/maintenance',
        name: 'maintenance',
    },
    {
        component: loadView('restaurant'),
        path: '/restaurant/:id',
        name: 'detail',
    },
    {
        component: loadView('hotel'),
        path: '/hotel/:slug',
        name: 'hotel_detail',
    },
    {
        component: loadView('menu'),
        path: '/menu-listing',
        name: 'menu',
    },
    {
        component: loadView('view_menu'),
        path: '/menu-view',
        name: 'view_menu',
    },
    {
        component: loadView('test'),
        path: '/map',
        name: 'map',
    },
    {
        component: loadView('location_detail'),
        path: '/item-detail',
        name: 'item_detail',
    },
    {
        component: loadView('menu_detail'),
        path: '/item',
        name: 'item',
    },
    {
        component: loadView('review_order'),
        path: '/review-order',
        name: 'basket',
    },
    {
        component: loadView('room'),
        path: '/review-order/select-room',
        name: 'room',
    },
    {
        component: loadView('customer'),
        path: '/basket/customer',
        name: 'customer',
    },
    {
        component: loadView('select_map'),
        path: '/basket/customer/select-map',
        name: 'select_map',
    },
    {
        component: loadView('feedback'),
        path: '/feedback',
        name: 'feedback',
    },
    {
        component: loadView('promotion'),
        path: '/promotions',
        name: 'promotion',
    },
    {
        component: loadView('orders'),
        path: '/orders',
        name: 'orders',
    },
    {
        component: loadView('order_detail'),
        path: '/orders/:orderId',
        name: 'order_detail',
    },
    {
        component: loadView('location'),
        path: '/select-location',
        name: 'location',
    },
    {
        component: loadView('order_completed'),
        path: '/completed',
        name: 'ordercompleted',
    },
    {
        component: loadView('errors/404'),
        path: '*',
        name: '404',
    },
];
